<template>
  <div class="navigations">
    <div class="navigation">
      <el-button class="btn-submit" @click="addCloumn"  icon="el-icon-plus">新增</el-button>
    </div>
    <el-table  :data="tableData" :header-cell-style="{background:'#f5f5f5',color:'rgb(82,82,82)',fontSize:'16px',fontWeight:400}">
      <el-table-column label="部门名称" align="center" prop="name"></el-table-column>
      <el-table-column label="成员人数" align="center" prop="members"></el-table-column>
      <el-table-column label="状态" align="center" prop="status">
        <template slot-scope="scope">
          {{scope.row.status===1?"正常":"禁用"}}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" prop="created_at"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <div v-if="roleName=='administrator'">
            <span @click="addCloumn(scope.$index, scope.row)" class="nav"><i class="el-icon-bianji"></i>修改</span> |
            <span @click="deleClunm(scope.$index, scope.row)" class="nav" style="color:red"><i class="el-icon-delete"></i>删除</span>
          </div>
        </template>


      </el-table-column>
    </el-table>
    <!-- 添加 -->
    <div class="dialog-father">
      <el-dialog
        :title="title"
        :visible.sync="editFormVisible"
        class="edit-dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
      <el-divider class="inst"></el-divider>
      <el-form ref="dataFrom" :model="dataFrom" :rules="rules">
        <el-form-item label="部门名称" prop="name">
          <el-input v-model="dataFrom.name" style="width:80%"></el-input>
        </el-form-item>
      </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            class="btn-submit"
            type="primary"
            @click="addFrom('dataFrom')"
            >确定</el-button
          >
          <el-button class="btn-cancel" @click="editFormVisible = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 分页组件 -->
    <Pagination
      v-if="total > 0"
      :currentPage="currentPage"
      :total="total"
      :limit="limit"
      @handleCurrentChange="handleCurrentChange"
    ></Pagination>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import { adddept ,getdepts, updateDept,deletedept} from "../../api/setting";

export default {
   name: "children",
  inject: ["reload"],
  data() {
    return {
      title:'创建部门',
      editFormVisible: false,
      roleName:localStorage.getItem('roleName'),
      user: localStorage.getItem("name"),
      currentPage: 1,
      total: 0,
      limit: 10,
      dataFrom:{
        name:'',
        id:''
      },
      tableData:[],
      rules:{
        name:[{required:true,message: '请输入名称', trigger: 'change'}],
        // phone:[{required:true,message: '请输入手机号码', trigger: 'change'}],
      },
    };
  },

  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    async re() {
      this.reload();
    },
    //获取列表数据
    getData(){
      let params={
        token: localStorage.getItem("token"),
        page:this.currentPage
      }
      getdepts(params).then(res=>{
         if (res.errno === 0) {
           this.tableData=res.data.data
           this.limit=res.data.per_page
           this.total=res.data.total
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.errno);
        }
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData()
    },
    addCloumn(index,row) {
      this.editFormVisible = true;
      if (row==''||row==undefined) {
        this.title='创建部门'
        this.dataFrom.name=''
        this.dataFrom.id=''
      }else{
        this.title='修改部门'
        this.dataFrom.name=row.name
        this.dataFrom.id=row.id
      }
    },
    addFrom(formName) {
      this.$refs[formName].validate((valid)=>{
        if (valid) {
          if (this.dataFrom.id=='') {
              let params={
              token: localStorage.getItem("token"),
              name:this.dataFrom.name
            }
            adddept(params).then(res=>{
                if (res.errno === 0) {
                this.$message({
                  type: "success",
                  message: res.data,
                });
                this.editFormVisible = false
                this.getData()
                this.re();
              } else if (res.errno === 401) {
                this.$store.dispatch("LogOut").then(() => {
                  location.reload(); // 为了重新实例化vue-router对象 避免bug
                });
              } else {
                this.$message.error(res.data);
              }
            })
          }
          else{
            let params={
              token: localStorage.getItem("token"),
              name:this.dataFrom.name,
              id:this.dataFrom.id
            }
            updateDept(params).then(res=>{
              if (res.errno===0) {
                  this.$message({
                    type:'success',
                    message:res.data
                  })
                   this.getData()
                   this.editFormVisible=false
                   this.re();
                }else if (res.errno===401) {
                  this.$store.dispatch('LogOut').then(()=>{
                    location.reload() //为了重新实例化vue-router对象 避免bug
                  })
                }
                else{
                  this.$message.error(res.error)
                }
            })
          }
        }
      })

    },
    deleClunm(index, row) {
      this.$confirm("确定要删除该项目吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          token: localStorage.getItem("token"),
          id: row.id,
        };
        deletedept(params).then((res) => {
            if (res.errno === 0) {
              this.$message({
                type: "success",
                message: res.data,
              });
              this.getData();
            } else if (res.errno === 401) {
              this.$store.dispatch("LogOut").then(() => {
                location.reload(); // 为了重新实例化vue-router对象 避免bug
              });
            } else {
              this.$message.error(res.data);
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("删除失败，请稍后再试！");
          });
      }).catch((err) => {
            this.loading = false;
          });
    },
  },
  mounted() {
    this.getData()
  },
};
</script>

<style scoped>
.home_bg {
  width: 100%;
  height: 100%;
  /* background: url("../../assets/img/back.jpg") no-repeat; */
}

.title {
  height: 100%;
  font-size: 30px;
  color: #0f215d;
  margin: auto;
  line-height: 837px;
  text-align: center;
}
.edit-dialog >>> .el-dialog {
  width: 25%;
}
.edit-dialog>>>.el-dialog__body{
  padding-top: 0px;
  /* padding-bottom: 80px; */
}
.inst {
  margin-top: 0px;
  margin-bottom: 40px;
}
.dialog-footer{
  text-align: right;
}
  .navigation  {
    /* cursor: pointer; 使文字可点击*/
    margin-bottom: 20px;
  }
 /* .navigations{
    padding: 10px;
  } */
 .nav {
  cursor: pointer;
  color: #2b52e9;
  margin-right: 8px;
}
.nav i{
  margin-right: 5px;
  margin-left: 8px;
}
 .dialog-father >>>  .el-dialog{
  width: 30%!important;
}
.edit-dialog>>>.el-input__inner{
  /* width: 394px; */
  height: 32px;
  font-size: 12px;
  color: #999999;
  border: 1px solid #cccccc;
}
.edit-dialog>>>.el-input__inner:hover{
  border: 1px solid #b0bceb;
  font-size: 12px;
}
.edit-dialog>>>.el-input__inner:focus{
  border:1px solid #2b52e9;
  font-size: 12px;
  color: #333333;
}
</style>





// WEBPACK FOOTER //
// src/views/setting/dmanage.vue